import lscache from 'lscache'

/**
 * @class Cache
 *
 * @description this is a wrapper for lscache node module
 */
class Cache {
  constructor(key, options = {}) {
    this.key = key
    this.options = Object.assign(
      {
        ttl: 60,
      },
      options,
    )
  }

  /**
   * @param key
   * @returns {Cache}
   */
  static create(key) {
    return new Cache(`${key}`)
  }

  get() {
    return lscache.get(this.key)
  }

  exists() {
    return !!this.get()
  }

  set(value) {
    lscache.set(this.key, value, this.options.ttl)
  }

  remove() {
    lscache.remove(this.key)
  }
}

export default Cache
